<template>
  <div
    :class="[
      jel_getClassObject(content),
      getIsMenuGaucheOuvert ? 'menu-gauche-ouvert' : 'menu-gauche-ferme',
    ]"
  >
    <div
      v-if="produit"
      :class="{
        'menu-droit-active': contentHeritageMenuDroit && $mq == 'xxl',
      }"
    >
      <b-container fluid class="bv-example-row">
        <b-row>
          <div
            class="p-0"
            :class="
              contentHeritageMenuDroit && !pleineLargeur && $mq == 'xxl' ? 'contenu-jeu' : 'col-12'
            "
          >
            <template v-if="idFamille">
              <b-row class="m-0 position-relative">
                <b-col class="col-12 col-xxl-8 p-0">
                  <JeuCasinoJouer :produit="produit" :lienRetour="contentLien" />
                </b-col>
                <b-col
                  class="col-12 col-xxl-4 d-flex justify-content-center flex-column px-0 pb-2 py-xxl-4 propriete-ced"
                >
                  <JeuCasinoPropriete :produit="produit" />
                  <JeuCasinoRegle :content="contentInfoRegle" />
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 p-0">
                  <ListeHorizontale :content="contentListeHorizontaleApercu" />
                </b-col>
              </b-row>
            </template>
            <template v-else>
              <JeuCasinoJouer :produit="produit" :lienRetour="contentLien" />
              <div :class="{ 'd-flex': pleineLargeur }">
                <div :class="{ 'contenu-jeu d-float': pleineLargeur }">
                  <JeuCasinoPropriete :produit="produit" />

                  <ListeHorizontale
                    v-if="contentListeHorizontaleApercu"
                    :content="contentListeHorizontaleApercu"
                  />
                  <div
                    v-if="contentTxtLegalComplet"
                    class="txt-legal-defaut caption-4 order-md-3 col-12 col-md-8 pl-0 pl-sm-2 pr-xxl-7 mx-md-0 mb-3"
                  >
                    <b-col v-html="jel_replaceTokens(contentTxtLegalComplet)" />
                  </div>

                  <JeuCasinoRegle :content="contentInfoRegle" />

                  <ListeHorizontale
                    v-if="contentListeHorizontaleJeuxSimilaires"
                    :content="contentListeHorizontaleJeuxSimilaires"
                  />
                  <!-- TODO: contentListeHorizontaleEtiquette hors portée livraison 1 NAV001 -->
                  <!-- <ListeHorizontale
                    v-if="contentListeHorizontaleEtiquette"
                    :content="contentListeHorizontaleEtiquette"
                  /> -->
                  <ListeHorizontale
                    v-if="contentListeHorizontaleCategorieTypeJeu"
                    class="mt-n1"
                    :content="contentListeHorizontaleCategorieTypeJeu"
                  />
                  <ListeHorizontale
                    v-if="contentListeHorizontaleFournisseur"
                    class="mt-n1"
                    :content="contentListeHorizontaleFournisseur"
                  />

                  <Heritage v-if="contentHeritageBas" :content="contentHeritageBas" />
                </div>
                <div
                  v-if="contentHeritageMenuDroit && pleineLargeur"
                  class="contenu-menu-droit d-none d-xxl-block bg-white border-left p-0"
                >
                  <Heritage v-if="contentHeritageMenuDroit" :content="contentHeritageMenuDroit" />
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="contentHeritageMenuDroit && !pleineLargeur"
            class="contenu-menu-droit d-none d-xxl-block bg-white border-left p-0"
          >
            <Heritage v-if="contentHeritageMenuDroit" :content="contentHeritageMenuDroit" />
          </div>
        </b-row>
      </b-container>
    </div>
    <div v-else>
      <div class="d-flex justify-content-center vh-100">
        <b-spinner
          variant="primary"
          class="align-self-center"
          type="grow"
          :label="$t('chargement')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import i18n from '@/js/i18n';

import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';

import ListeHorizontale from '@/components/container/liste/ListeHorizontale';
import Heritage from '@/components/base/Heritage';
import JeuCasinoJouer from '@/components/casino/jeu/JeuCasinoJouer';
import JeuCasinoPropriete from '@/components/casino/jeu/JeuCasinoPropriete';
import JeuCasinoRegle from '@/components/casino/jeu/JeuCasinoRegle';
import { PageMappingCasino, PageMappingErreurSeveur } from '@/helpers/PageMappingHelpers';

import { bus } from '@/main';

export default {
  name: 'JeuCasino',
  components: {
    ListeHorizontale,
    Heritage,
    JeuCasinoJouer,
    JeuCasinoPropriete,
    JeuCasinoRegle,
  },
  mixins: [mixinProduitCasino],
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          apercu: 'Aperçu',
          JouerEnLigne: 'Jouer en ligne à {titre}',
          jeuxSimilaires: 'Vous aimerez aussi',
          toutVoir: 'Tout voir',
          voirPlusDe: 'Voir plus de',
          txtLegalDefaut:
            'Toute défectuosité annule jeux et paiements. © Loto-Québec et ses filiales, {{Date|YYYY}}. Toute reproduction non autorisée de toute mise en page ou de tout contenu par quelque moyen que ce soit est strictement interdite.',
        },
      },
      en: {
        messageComponent: {
          apercu: 'Preview',
          JouerEnLigne: 'Play {titre} Online',
          jeuxSimilaires: 'You will also like',
          toutVoir: 'See all',
          voirPlusDe: 'See more',
          txtLegalDefaut:
            'Malfunction voids all pays and plays.© Loto-Québec and its subsidiaries, {{Date|YYYY}}. Unauthorized copying of any layout or any content by any means whatsoever is strictly prohibited.',
        },
      },
    },
  },
  data() {
    return {
      pleineLargeur: false,
    };
  },
  computed: {
    ...mapGetters({
      cedTableGetByName: 'cedTable/getByName',
      fournisseurGetByUuid: 'fournisseur/getByUuid',
      getIsMenuGaucheOuvert: 'menu/getIsMenuGaucheOuvert',
      getTableInfoFromName: 'cedTable/getTableInfoFromName',
      produitCasinoGetByNameI18n: 'produitCasino/getByNameI18n',
      produitCollectionGetUuidByNameI18n: 'produitCollection/getUuidByNameI18n',
    }),
    idProduit() {
      // produit en position 1 (Casino) ou position 2 (CED car famille en position 1)
      return this.$route.params.param2 ? this.$route.params.param2 : this.$route.params.param1;
    },
    idFamille() {
      // Si on a 2 paramètres (famille/produit) alors on a une famille (CED)
      return this.$route.params.param2 ? this.$route.params.param1 : null;
    },
    produit() {
      let aProduit;
      if (this.idFamille) {
        aProduit = this.getTableInfoFromName(this.idProduit, this.$isMobile());
        // return this.cedTableGetByName(this.idProduit);
      }
      aProduit = this.produitCasinoGetByNameI18n(this.idProduit);
      // aProduit == null == > la collection n'est pas charger. undefined le produit inexistent.
      if (this.idProduit !== undefined && aProduit === undefined) {
        // window.location.href = PageMappingErreurSeveur[404].siteUrl;
        this.returnToCasinoHome();
      }
      return aProduit;
    },
    contentListeHorizontaleApercu() {
      let content = {};
      if (this.produit.listeApercu) {
        content = this.getContentListeHorizontaleInformation(
          this.$i18n.t('messageComponent.apercu'),
          this.produit.listeApercu,
          '/media/image/mediaImage',
          {
            nbColMobile: 1,
            nbColTablette: 2,
            nbColDesktop: 2,
          }
        );
      }
      return content;
    },
    contentListeHorizontaleJeuxSimilaires() {
      return this.getContentListeHorizontale(
        this.$i18n.t('messageComponent.jeuxSimilaires'),
        this.produit.listeJeuSimilaire,
        null
      );
    },

    contentTxtLegalFournisseur() {
      const fournisseur = this.fournisseurGetByUuid(this.produit.fournisseur);
      if (fournisseur && fournisseur.txtLegal) {
        return this.$i18n.t(fournisseur.txtLegal);
      }
      return '';
    },

    contentTxtLegalComplet() {
      const textDefaut = this.$i18n.t('messageComponent.txtLegalDefaut');
      const textProduitCasino = this.produit.txtLegal ? this.$i18n.t(this.produit.txtLegal) : '';
      return textDefaut
        .concat(' ', this.contentTxtLegalFournisseur, ' ', textProduitCasino)
        .replace(/(<([^>]+)>)/gi, '');
    },

    // TODO: contentListeHorizontaleEtiquette hors portée livraison 1 NAV001
    // contentListeHorizontaleEtiquette() {
    //   // Dans l'ordre lister les produits ayant comme étiquette les 3 premiers étiquettes du jeu courant
    //   return this.getContentListeHorizontale('TODO:', null, 'TODO:');
    // },

    contentListeHorizontaleCategorieTypeJeu() {
      const categorie =
        this.produit.typeJeu && this.produit.typeJeu == 'masEnDirect'
          ? i18n.t(`casino.categorie.${this.produit.typeJeu}`)
          : i18n.t(`casino.categorie.${this.produit.categorie}`);
      return categorie
        ? this.getContentListeHorizontale(
            `${this.$i18n.t('messageComponent.voirPlusDe')} ${categorie.libelle}`,
            null,
            categorie.slug
          )
        : null;
    },
    contentListeHorizontaleFournisseur() {
      const fournisseur = this.fournisseurGetByUuid(this.produit.fournisseur);
      return fournisseur
        ? this.getContentListeHorizontale(
            `${this.$i18n.t('messageComponent.voirPlusDe')} ${fournisseur.nom}`,
            null,
            fournisseur['@name']
          )
        : '';
    },
    categorieInfo() {
      if (!this.content.listeCategorie) return null;
      const nodeFind = this.content.listeCategorie['@nodes'].find((node) => {
        return this.content.listeCategorie[node].categorie == this.produit.categorie;
      });

      return nodeFind ? this.content.listeCategorie[nodeFind] : null;
    },
    contentHeritageBas() {
      const lienInterneBas = this.categorieInfo?.lienInterneBas;
      if (!lienInterneBas) return null;

      const websitePath = this.$store.getters['routes/getWebsitePathByUuid'](lienInterneBas);
      return websitePath ? { lienInterne: websitePath } : null;
    },

    contentLien() {
      return {
        libelle: this.categorieInfo?.libelle,
        lien: this.categorieInfo?.lien,
      };
    },
    contentHeritageMenuDroit() {
      const lienInterneMenuDroit = this.categorieInfo?.lienInterneMenuDroit;

      if (!lienInterneMenuDroit) return null;

      const websitePath = this.$store.getters['routes/getWebsitePathByUuid'](lienInterneMenuDroit);
      return websitePath ? { lienInterne: websitePath } : null;
    },

    contentInfoRegle() {
      return {
        texteRegle: this.produit.texteRegle,
        listePdf: this.produit.listePdf,
      };
    },

    headerInfoProduit() {
      const titreProduit = i18n.locale == 'fr' ? this.produit.titreFr : this.produit.titreEn;
      const titrei18n = this.$i18n.t('messageComponent.JouerEnLigne', { titre: titreProduit });
      const descriptioni18n = this.produit.descriptionOg
        ? this.$i18n.t(this.produit.descriptionOg)
        : '';
      return {
        title: titrei18n,
        description: descriptioni18n,
        keywords: this.produit.keywords ? this.produit.keywords : '',
        noindex: this.produit.noindex == 'true' ? 'noindex' : 'index, follow',
        metaOGImage: this.produit.metaOGImage ? this.produit.metaOGImage : '',
      };
    },
  },
  mounted() {
    // Laisser le temps à produit d'obtenir ses informations. le 1er appel de produit est égale a null
    setTimeout(() => {
      try {
        this.busEmitUrlAutreLangue();
        this.busEmitHeaderInfo();
      } catch (e) {
        console.log('1er appel produit');
      }
    }, 3000);

    bus.$on('pleineLargeur', (isPleineLargeur) => {
      this.pleineLargeur = isPleineLargeur;
    });
  },
  activated() {
    const self = this;
    this.$nextTick(() => {
      self.busEmitUrlAutreLangue();
    });
  },
  methods: {
    getContentListeHorizontaleInformation(
      titre,
      listeInformation,
      componentIndex,
      nbColonne = null
    ) {
      const arrItems = [];
      let componentName = componentIndex.split('/');
      componentName = componentName[componentName.length - 1];

      listeInformation['@nodes'].forEach((item, index) => {
        listeInformation[item].classeCSS = 'w-100';
        listeInformation[item].format = 'mediaImageApercu';
        listeInformation[item].componentName = componentName;
        listeInformation[item].altImage = `${this.$i18n.t('messageComponent.apercu')} ${
          index + 1
        } - ${this.mixinProduitCasino_getTitre(false)}`;

        arrItems.push(listeInformation[item]);
      });
      let content = {
        titre,
        // à mettre si on veut la liste horizontale sous zone escamotable
        // afficherZoneEscamotable: true,
        listeHorizontale: {
          '@nodes': [0],
          0: {
            listeItems: arrItems,
            'mgnl:template': `jel-lm:components/${componentIndex}`,
            typeAffichage: {
              field: componentName,
            },
          },
        },
      };

      if (nbColonne) {
        content = this.definirNbColonneContenu(content, nbColonne);
      }

      return content;
    },
    getContentListeHorizontale(titre, listeIdProduit, nameProduitCollection) {
      let idProduitCollection = null;

      if (!listeIdProduit) {
        idProduitCollection = this.produitCollectionGetUuidByNameI18n(nameProduitCollection);
        if (!idProduitCollection) {
          return {};
        }
      }

      // "Tout voir" ne s'affiche que si on a une collection
      return {
        titre,
        libLien: this.$i18n.t('messageComponent.toutVoir'),
        lien: {
          field: idProduitCollection ? 'lienInterneCasinoCollection' : null,
          idProduitCollection,
        },
        listeHorizontale: {
          '@nodes': [0],
          0: {
            idProduitCollection,
            listeIdProduit,
            'mgnl:template': 'jel-lm:components/produit/produitCollection',
            typeAffichage: {
              field: 'CarteProduitCasino',
            },
          },
        },
        formatCarte: '5x6',
        produitCourantPageJeu: this.produit['@id'],
      };
    },
    definirNbColonneContenu(content, nbColonne) {
      content.nbColMobile = nbColonne.nbColMobile;
      content.nbColTablette = nbColonne.nbColTablette;
      content.nbColDesktop = nbColonne.nbColDesktop;
      return content;
    },
    busEmitUrlAutreLangue() {
      let autreLang =
        (i18n.locale == 'fr' ? '/en' : '/fr') +
        this.$store.getters['routes/getUrlFromWebsitePath'](
          PageMappingCasino.CASINO_PRODUIT.siteUrl
        );

      if (this.idFamille) {
        const listeFamille = i18n.t('casino.categorie.casinoendirect.famille');
        const famille = Object.keys(listeFamille).find(
          (key) => listeFamille[key].slug === this.idFamille
        );
        autreLang += `/${i18n.t(
          'casino.categorie.casinoendirect.slug',
          i18n.locale == 'fr' ? 'en' : 'fr'
        )}/${i18n.t(
          `casino.categorie.casinoendirect.famille.${famille}.slug`,
          i18n.locale == 'fr' ? 'en' : 'fr'
        )}/`;
      } else {
        autreLang += `/${i18n.t(
          `casino.categorie.${this.produit.categorie}.slug`,
          i18n.locale == 'fr' ? 'en' : 'fr'
        )}/`;
      }

      autreLang += i18n.locale == 'fr' ? this.produit.nameEn : this.produit.name;
      bus.$emit('urlAutreLangue', autreLang);
    },

    busEmitHeaderInfo() {
      bus.$emit('headerProduitInfo', this.headerInfoProduit);
    },

    returnToCasinoHome() {
      const uriReturn = this.$store.getters['routes/getUrlFromWebsitePath'](
        PageMappingCasino.CASINO_ACCUEIL.siteUrl
      );
      this.$router.push(uriReturn).catch(() => {
        console.log('Route inexistante: ', uriReturn);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contenu-jeu {
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}
.contenu-menu-droit {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
.menu-gauche-ouvert {
  @include media-breakpoint-up(xxl-menu-ouvert) {
    .contenu-jeu {
      -ms-flex: 0 0 80%;
      flex: 0 0 80%;
      max-width: 80%;
    }
    .contenu-menu-droit {
      -ms-flex: 0 0 20%;
      flex: 0 0 20%;
      max-width: 20%;
    }
  }
}

.menu-gauche-ferme {
  @include media-breakpoint-up(xxl-menu-ferme) {
    .contenu-jeu {
      -ms-flex: 0 0 80%;
      flex: 0 0 80%;
      max-width: 80%;
    }
    .contenu-menu-droit {
      -ms-flex: 0 0 20%;
      flex: 0 0 20%;
      max-width: 20%;
    }
  }
}

@include media-breakpoint-up(xxl) {
  .propriete-ced {
    position: absolute;
    top: 0;
    right: 0;
    min-height: stretch;
    z-index: 1;
    background: white;
    border-left: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }
}
.txt-legal-defaut {
  color: $couleur-bleu-fonce-lq;
}

// overide du 1600px par défaut pour inclure la barre de droite
// le contenu central du jeu doit être de 1600px et 400px pour le menu de droit = 2000px
.restreindre-largeur {
  max-width: 2000px;
}
</style>
